import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Browse",
    text: "Choose what you need — garments, footwear, innerwear, accessories or home essentials.",
  },
  {
    n: "02",
    title: "WhatsApp / Call",
    text: "Send us your requirements — sizes, brands or even a photo of what you're looking for.",
  },
  {
    n: "03",
    title: "Get It Delivered",
    text: "Enjoy convenient local delivery — free within 5 km on orders above ₹1,500.",
  },
];

export const HowToOrder = () => (
  <section className="bg-cream text-charcoal py-16 sm:py-24 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center max-w-xl mx-auto">
        <Eyebrow light>How to Order</Eyebrow>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-balance">
          Simple as one, two, three.
        </h2>
      </Reveal>
      <div className="mt-14 grid md:grid-cols-3 gap-10 md:gap-8">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div data-testid={`order-step-${i + 1}`} className="relative text-center md:text-left">
              <span className="font-mono text-6xl sm:text-7xl font-medium text-gold/50 select-none">
                {s.n}
              </span>
              <h3 className="mt-3 font-display text-2xl font-semibold">{s.title}</h3>
              <p className="mt-3 text-sm sm:text-base text-charcoal/60 leading-relaxed max-w-xs mx-auto md:mx-0">
                {s.text}
              </p>
              {i < 2 && (
                <span
                  className="hidden md:block absolute top-9 -right-4 w-8 border-t border-dashed border-charcoal/25"
                  aria-hidden="true"
                />
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
